import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const IndustriesSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const industries = [
    {
      name: language === 'fr' ? 'Pétrole et Gaz' : 
            language === 'ar' ? 'النفط والغاز' : 
            'Oil and Gas',
      description: language === 'fr' ? 'Solutions spécialisées pour les raffineries et les installations de traitement du pétrole et du gaz.' : 
                   language === 'ar' ? 'حلول متخصصة للمصافي ومنشآت معالجة النفط والغاز.' : 
                   'Specialized solutions for oil and gas refineries and processing facilities.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    },
    {
      name: language === 'fr' ? 'Industrie Chimique et Pétrochimique' : 
            language === 'ar' ? 'الصناعة الكيميائية والبتروكيماوية' : 
            'Chemical and Petrochemical Industry',
      description: language === 'fr' ? 'Instrumentation de précision pour les processus chimiques et les environnements exigeants.' : 
                   language === 'ar' ? 'أجهزة دقيقة للعمليات الكيميائية والبيئات الصعبة.' : 
                   'Precision instrumentation for chemical processes and demanding environments.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    },
    {
      name: language === 'fr' ? 'Production d\'Énergie' : 
            language === 'ar' ? 'إنتاج الطاقة' : 
            'Power Generation',
      description: language === 'fr' ? 'Systèmes de surveillance et de contrôle pour les installations de production d\'énergie.' : 
                   language === 'ar' ? 'أنظمة المراقبة والتحكم لمنشآت توليد الطاقة.' : 
                   'Monitoring and control systems for power generation facilities.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      name: language === 'fr' ? 'Agroalimentaire' : 
            language === 'ar' ? 'الصناعات الغذائية' : 
            'Food Industry',
      description: language === 'fr' ? 'Solutions d\'instrumentation avancées pour optimiser les processus de production alimentaire.' : 
                   language === 'ar' ? 'حلول أجهزة متقدمة لتحسين عمليات إنتاج الغذاء.' : 
                   'Advanced instrumentation solutions to optimize food production processes.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      )
    }
  ];

  return (
    <section className="section section-light" style={{ 
      color: 'var(--assco-gray-900)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="blob" style={{ top: '-30%', right: '-20%', opacity: 0.1 }}></div>
      <div className="blob" style={{ bottom: '-30%', left: '-20%', opacity: 0.1 }}></div>
      <div className="bg-pattern"></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <h2 className="text-center fade-in" style={{ 
          color: 'var(--assco-gray-900)', 
          marginBottom: '1rem',
          position: 'relative',
          paddingBottom: '1.25rem',
          display: 'inline-block'
        }}>
          {language === 'fr' ? 'Industries Que Nous Servons' : 
           language === 'ar' ? 'الصناعات التي نخدمها' : 
           'Industries We Serve'}
          <span style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            backgroundColor: 'var(--assco-orange)',
            borderRadius: '2px'
          }}></span>
        </h2>
        
        <p className="text-center fade-in" style={{ 
          color: 'var(--assco-gray-700)',
          maxWidth: '800px',
          margin: '0 auto 3rem'
        }}>
          {language === 'fr' 
            ? 'Nous fournissons des solutions d\'instrumentation de pointe adaptées aux besoins spécifiques de diverses industries.' 
            : language === 'ar' 
            ? 'نقدم حلول أجهزة متطورة مصممة لتلبية الاحتياجات المحددة لمختلف الصناعات.' 
            : 'We provide cutting-edge instrumentation solutions tailored to the specific needs of various industries.'}
        </p>
        
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '2rem'
        }}>
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="industry-card fade-in"
              style={{
                backgroundColor: 'white',
                borderRadius: 'var(--radius-lg)',
                padding: '2rem',
                backdropFilter: 'blur(10px)',
                border: '1px solid var(--assco-gray-100)',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease',
                animationDelay: `${0.1 * index}s`
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
              }}
            >
              <div style={{ 
                color: 'var(--assco-orange)',
                marginBottom: '1.5rem'
              }}>
                {industry.icon}
              </div>
              
              <h3 style={{ 
                color: 'var(--assco-gray-900)',
                fontSize: '1.5rem',
                marginBottom: '1rem'
              }}>
                {industry.name}
              </h3>
              
              <p style={{ 
                color: 'var(--assco-gray-600)',
                marginBottom: '1.5rem',
                lineHeight: '1.6'
              }}>
                {industry.description}
              </p>
              
              <Link 
                to="/projects"
                style={{
                  color: 'var(--assco-orange)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  fontWeight: '500',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.color = 'var(--assco-yellow)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.color = 'var(--assco-orange)';
                }}
              >
                {language === 'fr' ? 'Voir les projets' : 
                 language === 'ar' ? 'عرض المشاريع' : 
                 'View projects'}
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', marginLeft: '0.5rem' }} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          ))}
        </div>
        
        <div className="text-center" style={{ marginTop: '3rem' }}>
          <Link 
            to="/services"
            className="btn btn-primary fade-in"
          >
            {language === 'fr' ? 'Explorer Nos Services' : 
             language === 'ar' ? 'استكشف خدماتنا' : 
             'Explore Our Services'}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
